import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "react-toastify";

const ProtectedRoute = ({ token }) => {
  if (token === null) {
    toast.error("You haven't access to this page.");
    return <Navigate to={"/signin"} />;
  } else {
    return <Outlet />;
  }
};

export default ProtectedRoute;
